import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function CaretSolidIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-caret-solid-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.11 25.32l8.43-8.43c.99-.99.29-2.67-1.11-2.67H11.57c-1.39 0-2.09 1.69-1.11 2.67l8.43 8.43c.61.61 1.61.61 2.22 0z"
  })));
}